import type { Session } from '../../domain/entities/session';
import type { AuthRepository } from '../../domain/ports/auth-repository';
import type { SessionFactory } from '../ports/session-factory';

export interface ActivateMfaInput {
  mfaToken: string;
  code: string;
  email: string;
}

export interface ActivateMfaResult {
  session: Session;
  recoveryCodes: string[];
}

interface ActivateMfaUseCaseDeps {
  authRepository: AuthRepository;
  createSession: SessionFactory;
}

export async function activateMfaUseCase(
  input: ActivateMfaInput,
  deps: ActivateMfaUseCaseDeps,
): Promise<ActivateMfaResult> {
  const result = await deps.authRepository.activateMfa({
    mfaToken: input.mfaToken,
    code: input.code,
  });
  const session = deps.createSession({ ...result, email: input.email });
  if (!session) throw new Error('invalid token in response');

  return { session, recoveryCodes: result.recoveryCodes };
}
